<footer class="footer">
  <div class="d-flex align-items-center justify-content-center justify-content-md-between flex-wrap">
    <div>
    Asociația Crescătorilor de Bovine pentru Carne din România
    </div>

    <div class="d-none d-md-block">
      Email: asociatia@acbcr.ro
    </div>
  </div>
</footer>
